enum BusinessBranchNumEmployees {
    oneToFourteen,
    fifteenPlus
}

export default BusinessBranchNumEmployees
